import DrawBase from "../DrawBase"
import EditEllipsoid from "./EditEllipsoid"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawEllipsoid extends DrawBase {


    constructor(options) {
        super(options);
    }
    getEditInterface(){
        return EditEllipsoid;
    }

    getTypeName() {
        return "球体";
    }
    
    getType() {
        return "ellipsoid_Nor";
    }

    checkLeftClick() {
        if (this.positionsTemp.length <= 1) {
            return true;
        }
        return false;
    }

    checkMouseMove() {
        if (this.positionsTemp.length <= 1) {
            return false;
        }
        return true;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var minR = 1;
        var positions = [];
        var rProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            var center = positions[0];
            var outline = positions[1];

            var r = Cesium.Cartesian3.distance(center, outline);
            r = r ? r : r + minR;
            return new Cesium.Cartesian3(r, r, r);
        }, false);

        var ellipsoid = this.createEllipsoid(rProperty);
        entity.position = this.positionsTemp[0].clone();
        entity.ellipsoid = ellipsoid;

    }


    loadDynamicGraph(entity, data) {
        var $this = this;
        var minR = 1;
        var positions =  JSON.parse(data.editPositions);
        var rProperty = new $this.Cesium.CallbackProperty(function () {
  
            var center = positions[0];
            var outline = positions[1];

            var r = Cesium.Cartesian3.distance(center, outline);
            r = r ? r : r + minR;
            return new Cesium.Cartesian3(r, r, r);
        }, false);

        var ellipsoid = this.createEllipsoid(rProperty);
        entity.position = positions[0];
        entity.ellipsoid = ellipsoid;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "ellipsoid")
    }

}


export default DrawEllipsoid;